var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fillRule: "evenodd"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.534 12.808a.62.62 0 0 1-.442-.183.63.63 0 0 1 0-.883l1.692-1.692-1.692-1.692a.63.63 0 0 1 0-.883.63.63 0 0 1 .883 0l2.134 2.133a.63.63 0 0 1 0 .884l-2.134 2.133a.62.62 0 0 1-.441.183"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.608 10.675H8.133a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h8.475a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.8 17.292c-4.292 0-7.292-3-7.292-7.292s3-7.292 7.292-7.292a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625c-3.558 0-6.042 2.484-6.042 6.042s2.484 6.042 6.042 6.042a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625"
})));
export default SvgLeave;